<template>
  <div style="width: 100%;height: 100%;">
    <div id="header" class="header header-fixed">
      <div class="header-container container-width">
        <a href="#/about" class="logo router-link-active">
        </a>
        <ul id="header-nav" class="header-nav">

          <li v-for="(item,index) in menus" >
            <a :href="item.path" :class="item.id==curMenu?'router-link-exact-active router-link-active active':''"
               :aria-current="item.id==curMenu ?'page':false" @click.prevent="selectMenu(item)">
              {{item.name}}
            </a>
            <span class="nav-separator" v-if="index<menus.length-1"></span>
          </li>
        </ul>

      </div>
    </div>

    <div style="width: 100%;">
      <router-view/>
    </div>


    <div class="footer">
      <div class="footer-container container-width">
        <ul class="footer-nav">
          <li v-for="(item,index) in menus">
            <a href="" :class="item.id==curMenu?'router-link-exact-active router-link-active':''"
               :aria-current="item.id==curMenu ?'page':false" @click.prevent="selectMenu(item)">
              {{item.name}}
            </a>
          </li>

        </ul>
        <p class="footer-copyright">
          Copyright © 2012-2024 深圳市雁来信网络科技有限公司
          <a href="https://beian.miit.gov.cn/" target="_blank">
            粤ICP备2024250931号
          </a>
        </p>
      </div>
    </div>

  </div>

</template>


<script>
  export default {
    data () {
      return {
        menus:[
          {id:'1',name:'关于我们',path:'/about'},
          {id:'2',name:'企业风采',path:'/mien'},
          {id:'3',name:'媒体报道',path:'/news'},
          {id:'4',name:'联系我们',path:'/contact'},
          {id:'5',name:'直播公会入驻',path:'/guild'},
        ],
        curMenu:'1',

      }
    },
    methods: {
      selectMenu(item){
        this.curMenu = item.id;
        this.$router.push({ path: item.path });
      },


    },
    mounted() {
      if(this.curMenu=='1'){
        this.$router.push({ path: '/about' });
      }
    }

  }
</script>


<style scoped>

  .header {
    background-image: -webkit-gradient(linear,left top,left bottom,from(rgba(22,11,11,.82)),color-stop(98%,rgba(0,0,0,0)));
    background-image: -o-linear-gradient(top,rgba(22,11,11,.82) 0,rgba(0,0,0,0) 98%);
    background-image: linear-gradient(180deg,rgba(22,11,11,.82),rgba(0,0,0,0) 98%);
    width: 100%;
    height: 80px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    z-index: 4;
    top: 0;
    left: 0;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff
  }

  .header .container-width {
    margin: 0
  }

  .header-container {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .header-container,.header-nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between
  }

  .header-nav {
    padding-right: 40px
  }

  .header-nav li {
    padding: 0 23px;
    position: relative
  }

  .header-nav a {
    color: #fff;
    display: block;
    padding: 7px 0;
    border-bottom: 4px solid rgba(0,0,0,0);
    -webkit-transition: all .2s ease-in;
    -o-transition: all .2s ease-in;
    transition: all .2s ease-in
  }

  .header-nav a:hover {
    border-bottom-color: #ffd321
  }

  .header-nav .active {
    border-bottom-color: #ffd321
  }

  .logo {
    /* background: url(../../assets/img/logo_white.0b608b16.png) no-repeat; */
    background-size: 97px 36px;
    width: 97px
  }

  .logo,.nav-weibo {
    height: 36px;
    display: block
  }

  .nav-weibo {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA4CAMAAACbrRsRAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAB4UExURUdwTP///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////4MhPqcAAAAndFJOUwBMAhcvpeb89UDhEPAIBZzrrnchJ5EzvWK1xUZ/ittmVDobblrQWeJZDnMAAAGMSURBVHja7dLXjpxAFATQInQiDnlgIhO2/v8P3S2QvNJawFj2G+ex1XWlG7Db7f6Ph/G8Gn/jqWhF5xgfE5zIEz7kP8r7eBSKVN7GRGgCfFMVpH5gXZ0npLoDTlxebgGQkznWpI2iEwHOkWRikEZMsrXm3pzFcDIzlkr6aMgWi0LJmfYRvMrLMQNyjriTBkuMJmf63ClaHVDyBG8lGib8KcSNI57k0ogDyT9GsxYoKLGg4+TQCdEP13nSPpwzxULyxulea0zi10Dy6mVwAn9hoZKkfmY2Y07hvFXtio1Y8UVS2kjdK/ffwPHIDfdbkKr9PWUVzq9WhGVyOtOBltJkMR+iU2GRIk9ARUadut3IA5z7luibbF1zfYZTlJAJLP9MS/pY1JAvF/0Calr9PHbrgmW14gAEemjNm2QSTvUsGWPFhSyBu6ZzDacnSxusyQTZpIifQuSe667qaR0M1vmlpiwfcyEjFK0iwCZVo8lrn+di0LRU0WKz1Gu6SE3timOMT6V12FYpdrvdv/YLMoA2BKHfNZwAAAAASUVORK5CYII=) no-repeat;
    background-size: 36px 36px;
    width: 36px
  }

  .nav-separator {
    width: 1px;
    height: 10px;
    background: hsla(0,0%,100%,.3);
    position: absolute;
    right: 0;
    top: 11px
  }

  .header-fixed {
    position: fixed;
    background: #fff;
    border-bottom: 1px solid #eaeaea
  }

  .header-fixed a {
    color: #353535
  }

  .header-fixed .logo {
     background-image: url(../../assets/img/logo.jpg)
  }

  .header-fixed .nav-weibo {
    background-image: url(data:image/png;base64,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)
  }

  .header-fixed .nav-separator {
    background: rgba(0,0,0,.3)
  }


  .footer {
    height: 160px;
    background: #000;
    text-align: center
  }

  .footer,.footer a {
    color: rgb(234 234 234);
  }

  .footer a:hover {
    color: #fff
  }

  .footer-nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    text-align: center
  }



  .download-multi a {
    display: block;
    overflow: hidden;
    margin-left: 16px;
    text-indent: -999px
  }

  .footer-nav {
    width: 720px;
    padding-top: 40px;
    margin: 0 auto
  }


  .footer-copyright {
    padding-top: 18px;
    font-size: 14px
  }


</style>



// WEBPACK FOOTER //
// src/views/Index.vue